export default {
  links: {
    batches: undefined,
    notifications: undefined,
  },
  batches: [],
  notifications: {},
};
